import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const OFFERS = [
  {
    num: "01",
    length: "Three to six months",
    price: "$4,250",
    unit: "per month",
    includes: [
      "All furnishings, linens & kitchenware",
      "High-speed Wi-Fi included",
      "Utilities capped — first month included",
      "Weekly cleaning available",
    ],
  },
  {
    num: "02",
    length: "Three month stays",
    price: "$4,500",
    unit: "per month",
    includes: [
      "All-inclusive — no extras",
      "All furnishings, linens & kitchenware",
      "High-speed Wi-Fi included",
      "Utilities included",
    ],
  },
];

const CinematicPricing = () => (
  <section className="bg-[#0D0D0D] text-[#F5F1EA] py-28 md:py-40" data-testid="cinematic-pricing">
    <div className="container-premium">
      <div className="max-w-3xl mb-20">
        <div className="flex items-center gap-4 mb-8">
          <span className="chapter-num">07</span>
          <span className="h-px w-12 bg-[#C4A570]/60" />
          <span className="chapter-label">The Details</span>
        </div>
        <h2 className="cinematic-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-[0.98]">
          Two rates.{" "}
          <span className="cinematic-serif-italic">Ninety-day minimum.</span>
        </h2>
        <p className="cinematic-body mt-8 max-w-md text-[15px] md:text-base">
          One rate for the season-long stays. One for the shorter contracts.
          Both include everything you need to move in with a suitcase.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 md:gap-12">
        {OFFERS.map((offer, i) => (
          <motion.div
            key={offer.num}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, delay: i * 0.1 }}
            className="border-t border-[#C4A570]/25 pt-10"
          >
            <div className="flex items-start justify-between mb-10">
              <span className="chapter-num">{offer.num}</span>
              <span className="chapter-label text-right">{offer.length}</span>
            </div>
            <div className="flex items-baseline gap-3 mb-10">
              <span className="cinematic-serif text-6xl md:text-7xl text-[#F5F1EA]">
                {offer.price}
              </span>
              <span className="chapter-label text-[9px]">{offer.unit}</span>
            </div>
            <ul className="space-y-4">
              {offer.includes.map((line) => (
                <li key={line} className="flex items-start gap-4 cinematic-body text-sm">
                  <span className="mt-2 w-4 h-px bg-[#C4A570]" />
                  <span>{line}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>

      <div className="mt-24 flex flex-col md:flex-row justify-between items-start md:items-center gap-8 border-t border-[#C4A570]/20 pt-12">
        <div>
          <p className="chapter-label mb-3">Pet-friendly</p>
          <p className="cinematic-body text-[#F5F1EA]/90">
            One-time <span className="cinematic-serif-italic text-[#C4A570]">$150</span> cleaning fee. No recurring pet rent.
          </p>
        </div>
        <Link
          to="/contact"
          data-testid="pricing-cta-btn"
          className="inline-flex items-center gap-3 border border-[#C4A570] text-[#C4A570] hover:bg-[#C4A570] hover:text-[#0D0D0D] transition-colors duration-500 px-8 py-3.5 rounded-full text-[11px] uppercase tracking-[0.35em]"
        >
          Request a Quote
          <span className="w-3 h-px bg-current" />
        </Link>
      </div>
    </div>
  </section>
);

export default CinematicPricing;
